module.exports = __webpack_public_path__ + "public/img/yishiyong.6aafeadc.png";